import React from 'react';
import { useEffect, useState } from 'react'

import { CustomerCardModel } from './models/CustomerCardModel';
import { SimulatorModel } from './models/SimulatorModel';
import { useSelector, useDispatch } from 'react-redux'
import './assets/css/emails.css'
import { Menu } from './_Menu'
import Header from './Header';
import Footer from './_Footer'
//import RenewalsManagement from './SystemManagement/_renewalsManagement'
//import './assets/css/systemManagement.css'
import RenewalsManagement from './SystemManagement/_renewalsManagement'
import './assets/css/systemManagement.css'
import ProductionMenegement from './SystemManagement/_productionManagement'


const SystemManagement = () => {

    const [renewalsActive, setRenewalsActive] = useState<boolean>(true);
    const [productionActive, setProductionActive] = useState<boolean>(false);
        
    useEffect(() => {

    },
        []);


        const activeProduction = async () => {
                 setRenewalsActive(false);
            setProductionActive(true);
        
            };

            const activeRenewlas = async () => {
                 setRenewalsActive(true);
            setProductionActive(false);
        
            };

       
    // documents end

    return (
<div className='main-content rtl'>
              <Menu activePage='Leads' />
              <div className='center-content'>
                <Header PageName="ניהול מערכת" />
                <div className='lleads'>
                 <section className="main-body"></section>
<div className="">
            <div className="emails-tab-row">
                <div className={`email-tab email-tab-clients ${renewalsActive?"selected":""}`}>
                    <div className="top-border" ></div>
                    <div className="tab-content" onClick={()=>activeRenewlas()}><div className="label">חידושים</div>
                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${productionActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeProduction()}>
                        <div className="label" >פרודוקציה</div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div className='body'>
            {renewalsActive?<RenewalsManagement></RenewalsManagement>:""}
            {productionActive?<ProductionMenegement></ProductionMenegement>:""}
            
        </div>
                  
                  <footer className="footer emails-list-footer emails-list-view">
                    
                  </footer>

                </div>
              </div>
              </div>








        

    )
}

export default SystemManagement;

export {};